import { render, staticRenderFns } from "./LvRiskIcon.vue?vue&type=template&id=ca0588f6"
import script from "./LvRiskIcon.vue?vue&type=script&lang=js"
export * from "./LvRiskIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports